export function getVersionFromBaseUri(): string | undefined {
  const match = document.baseURI.match(/[/]_version[/]([^/]+)[/]$/);
  return match?.at(1);
}
